import axios from 'axios'
import md5 from 'js-md5';
import { getToken, getPreType } from './auth'
import config from './config'
import qs from 'qs';
const app_id = config.app_id;
const app_secret = config.app_secret;
const ProxyType = config.ProxyType;
const proxy = config.proxy;
// create an axios instance
const service = axios.create({})
const noInterceptor = []

// request interceptor
service.interceptors.request.use(
  config => {
    // 加入cancelToken对象，路由切换时清除上一个路由的未响应请求信息
    try {
      config.cancelToken = new axios.CancelToken((calcel) => {
        //这里一直报push错误，遂注释掉
        /* window._axiosPromiseArr.push({ calcel }) */
      })
    } catch (error) {
      console.log(error)
    }
    if (noInterceptor.indexOf(config.url) === -1) { }
    return config
  },
  error => {
    // store.dispatch('common/setReqNum', 1)
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    if (noInterceptor.indexOf(response.config.url) === -1) {
      window.setTimeout(() => {

      }, 1)
    }
    return response
  },
  err => {
    window.setTimeout(() => {
    }, 1)
    if (axios.isCancel(err)) {
      return Promise.reject(err)
    }
    console.log('err  ' + err, err.response) // for debug
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误'
          break

        case 401:
          err.message = '未授权，请登录'
          break

        case 403:
          err.message = '拒绝访问'
          break

        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`
          break

        case 408:
          err.message = '请求超时'
          break

        case 500:
          err.message = '服务器内部错误'
          break

        case 501:
          err.message = '服务未实现'
          break

        case 502:
          err.message = '网关错误'
          break

        case 503:
          err.message = '服务不可用'
          break

        case 504:
          err.message = '网关超时'
          break

        case 505:
          err.message = 'HTTP版本不受支持'
          break

        default:
          err.message = '未知错误'
      }
    }
    // this.$api.msg(err.message,3*1000);
    const { status } = err.response || {}
    return Promise.reject(err)
  }
)

function changeOptData(option) {
  let data = {
    ...option
  };
  let timestamp = parseInt(new Date().getTime() / 1000);
  let token = getToken();
  let sign = [];
  data.timestamp = timestamp;
  data.app_id = config.app_id;
  token ? data.token = token : "";
  let mdKey = '';
  Object.keys(data).forEach((key) => {
    sign.push(key);
  });
  sign.sort().forEach((item, index) => {
    if (item != "uploadFile") {
      mdKey += `${item}=${data[item]}`;
    }
  });
  data.sign = md5(`${mdKey}${config.app_secret}`);
  return data;
};

const request = (param) => {
  if (param.method == "post") {
    param.data = qs.stringify(changeOptData(param.data));
  } else if (param.method == "get") {
    if (param.url.split("?").length > 1) {
      let params = param.url.split("?")[1].split("&") || param.params;
      let obj = {};
      params.map(item => obj[item.split("=")[0]] = item.split("=")[1]);
      param.url = param.url.split("?")[0] + "?" + qs.stringify(changeOptData(obj));
    } else if (param.params) {
      param.params = changeOptData(param.params);
    } else {
      param.url = param.url.split("?")[0] + "?" + qs.stringify(changeOptData({}));
    }
  }

  return new Promise((resolve, reject) => {
    service(param).then((res) => {
      const data = res.data;
      if (data.code === 0) {
        resolve(data)
      } else {
        if (data.code === -1 || data.status === 5001 || data.status === 5002) {
          if (data.code === -1) {
            //跳转login的操作
          }
        }
        reject(data)
      }
    }).catch((err) => { reject(err) })
  })
}
export default request
